import dynamic from "next/dynamic";
import { useI18n } from "@/i18n/I18nProvider";
import Image from "next/image";
import Box from "@mui/material/Box";
const PageHead = dynamic(() => import("@/components/PageHead"));
const Campaign = dynamic(() => import("@/components/campaign/Campaign"));

const mobile_images = [
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/golf-car.png", alt: "golf-car" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/motorcycle.png", alt: "motorcycle" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/car.png", alt: "car" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-interior.png", alt: "home-interior" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/shopping.png", alt: "shopping" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/trucks.png", alt: "trucks" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mortagage.png", alt: "mortagage" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/furniture.png", alt: "furniture" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/clubs.png", alt: "clubs" },
];

const desktop_images = [
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/clubs.png", alt: "clubs" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/furniture.png", alt: "furniture" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/shopping.png", alt: "shopping" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/trucks.png", alt: "trucks" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/motorcycle.png", alt: "motorcycle" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/golf-car.png", alt: "golf-car" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-interior.png", alt: "home-interior" },
  { src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/car.png", alt: "car" },
];

const desktopPositions = [
  // LEFT side
  { top: "80px", left: "80px", rotate: "1deg" },
  { top: "250px", left: "80px", rotate: "-2deg" },
  { top: "460px", left: "90px", rotate: "5deg" },
  { bottom: "60px", left: "90px", rotate: "-6deg" },

  // RIGHT side
  { top: "80px", right: "100px", rotate: "-1deg" },
  { top: "280px", right: "80px", rotate: "2deg" },
  { top: "480px", right: "80px", rotate: "5deg" },
  { bottom: "40px", right: "80px", rotate: "6deg" },
];

function Polaroid({ src, alt, style }) {
  return (
    <Box
      sx={{
        position: "absolute",
        width: "200px",
        height: "200px",
        borderRadius: "13px",
        p: "10px",
        bgcolor: "white",
        boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
        transform: `rotate(${style.rotate})`,
        ...style,
        zIndex: 0,
        "& img": { borderRadius: 2 },
      }}
    >
      <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
        <Image src={src} alt={alt} fill style={{ objectFit: "cover" }} />
      </Box>
    </Box>
  );
}

function CollageSection({ children }) {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        bgcolor: "transparent",
      }}
    >
      {/* Background Layout */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: {
            xs: "url(https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/layout-mobile.png)",
            lg: "url(https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/layout.png)",
          },
          backgroundSize: "cover",
          backgroundPosition: "center",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* ===== Mobile Catalogue ===== */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: { xs: "grid", lg: "none" },
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "8px",
          maxWidth: 420,
          mx: "auto",
          pt: 3,
          mb: 3,
          px:2,
        }}
      >
        {mobile_images.slice(0, 9).map((img, i) => {
          const rotations = [
            "-6deg",
            "-8deg",
            "-10deg",

            "-6deg",
            "-8deg",
            "-10deg",

            "-6deg",
            "-8deg",
            "-10deg",
          ];

          const shifts = [
            { x: 0, y: 0 },
            { x: 0, y: -10 },
            { x: 0, y: -20 },

            { x: 0, y: 0 },
            { x: 0, y: -10 },
            { x: 0, y: -20 },

            { x: 0, y: 0 },
            { x: 0, y: -10 },
            { x: 0, y: -20 },
          ];

          return (
            <Box
              key={i}
              sx={{
                position: "relative",
                borderRadius: "18px",
                p: "5px",
                bgcolor: "#fff",
                boxShadow: "0 12px 28px rgba(0,0,0,0.14)",
                transform: `rotate(${rotations[i]}) translate(${shifts[i].x}px, ${shifts[i].y}px)`,
                transformOrigin: "center",
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  aspectRatio: "1 / 1",
                  borderRadius: "14px",
                  overflow: "hidden",
                }}
              >
                <Image
                  src={img.src}
                  alt={img.alt}
                  fill
                  style={{ objectFit: "cover" }}
                />
              </Box>
            </Box>
          );
        })}
      </Box>

      {/* ===== Desktop Catalogue ===== */}
      <Box sx={{ display: { xs: "none", lg: "block" } }}>
        {desktop_images.slice(0, 8).map((img, i) => (
          <Polaroid
            key={i}
            src={img.src}
            alt={img.alt}
            style={desktopPositions[i]}
          />
        ))}
      </Box>

      {/* ===== Center Content (Transparent wrapper) ===== */}
      <Box
        sx={{
          position: "relative",
          maxWidth: 920,
          mx: "auto",
          bgcolor: "transparent",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default function Index() {
  const { t } = useI18n();

  return (
    <>
      <PageHead />
      <Box className="horizontal-safe-padding vertical-safe-padding">
        <CollageSection>
          <Campaign
            type="catalogue"
            title={t.Campaign.catalogueTitle}
            subTitle={t.Campaign.catalogueSubTitle}
            source={22}
            isCatalogueStyle={true}
          />
        </CollageSection>
      </Box>
    </>
  );
}
